import { fetchUserSettings } from '../apis/api-users.js';
import { userStatus$ } from '../stores/store-main.js';
import { userSettings$, user$ } from '../stores/store-user.js';
import { USER_ROLE } from './helper-users.js';
import { logoutFromSSO, oidcClient } from './oidcClient.js';
import { getOidcLoginEnabled, isSubscriptionExpiredEnabled, } from '../urlHandling/urlSearchParams.js';
export async function initializeOidcUserWithToken() {
    try {
        await validateOidcUserToken();
        const userSettings = await fetchUserSettings();
        userSettings$.next(userSettings);
    }
    catch (e) {
        console.error('could not initialize user', e);
    }
}
export async function validateOidcUserToken() {
    if (!getOidcLoginEnabled())
        return true;
    try {
        const token = await oidcClient.refreshToken();
        if (!token || token === '') {
            setOidcUserStatus(null);
            return false;
        }
        const parsedToken = oidcClient.parseJwtPayload(token);
        if (parsedToken && parsedToken.email !== user$.value?.email) {
            user$.next({
                email: parsedToken.email,
                firstName: parsedToken.firstName,
                userid: Number(parsedToken.customer_number),
            });
            setOidcUserStatus(parsedToken);
        }
        return !!parsedToken;
    }
    catch (e) {
        console.error('token not valid', e);
        setOidcUserStatus(null);
        return false;
    }
}
export function resolveRoles(token) {
    let roles = token.roles;
    if (!Array.isArray(token.roles)) {
        roles = [];
        [
            'subscribed-user',
            'subscription-pending',
            'schweizmobil-user',
            'subscription-expired',
        ].forEach((k) => {
            if (token[k] === 'true') {
                roles.push(k);
            }
        });
    }
    return roles;
}
export function setOidcUserStatus(token) {
    if (!token) {
        userStatus$.next(USER_ROLE.notLogged);
        user$.next(null);
        return;
    }
    if (isSubscriptionExpiredEnabled) {
        userStatus$.next(USER_ROLE.subscriptionExpired);
        return;
    }
    const roles = resolveRoles(token);
    let role = USER_ROLE.noRole;
    for (const k of [
        USER_ROLE.subscriptionExpired,
        USER_ROLE.subscribedUser,
        USER_ROLE.subscriptionPending,
    ]) {
        if (roles.includes(k)) {
            role = k;
            break;
        }
    }
    userStatus$.next(role);
}
export async function oidcLogin() {
    localStorage.setItem('appPreLoginURL', document.location.href);
    try {
        const loginURL = await oidcClient.createAuthorizeAndUpdateLocalStorage();
        document.location = loginURL;
    }
    catch (error) {
        console.error('Error:', error);
    }
}
export async function oidcLogout() {
    logoutFromSSO();
}
//# sourceMappingURL=oidcUser.js.map